import { getImage } from "gatsby-plugin-image";
import React from "react";
import Container from "./Layout/Container";
import SectionTitle from "./SectionTitle";
import Button from "./Button";

const ImageOverBanner = ({
  fullWidth = false,
  data,
  className = "px-4",
  bannerClassName = "px-10 py-8 h-[400px]",
  verticalAlign = "end",
  button = null,
}) => {
  const { title = "", subTitle = "", content, bannerImage } = data || {};
  const imageData = bannerImage
    ? getImage(bannerImage?.localFile?.childImageSharp?.gatsbyImageData)
    : null;

  const backgroundImageStyle = imageData
    ? {
        backgroundImage: `url(${imageData.images.fallback.src})`,
      }
    : {};

  const InnerContainer = fullWidth ? Container : React.Fragment;
  const innerContainerProps = fullWidth
    ? { background: "transparent", className: "mx-auto overflow-visible", containerClassName: "px-4" }
    : {};

  return (
    <Container fullWidth={fullWidth} containerClassName={className}>
      <div
        className={`justify-left relative inset-0 flex items-${verticalAlign} bg-gradient-to-t from-primary to-transparent bg-cover bg-center ${bannerClassName}`}
        style={backgroundImageStyle}
      >
        <InnerContainer {...innerContainerProps}>
          <div className="max-w-full">
            <SectionTitle
              title={title}
              color="white"
              weight="bold"
              className="mb-3"
            />
            <SectionTitle
              title={subTitle}
              color="white"
              weight="normal"
              className="mb-3"
            />
            {content ? (
              <p
                className={`page-content mb-0 mt-4 font-openSans text-xl text-white`}
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              ></p>
            ) : null}
            {button && <Button {...button} />}
          </div>
        </InnerContainer>
      </div>
    </Container>
  );
};

export default ImageOverBanner;
